// import Dict from '@baifendian/adherev-util-dict';
// import Intl from '@baifendian/adherev-util-intl';
export default {
    initStatic: function () { },
    initRemote: function () { },
};
